export default __webpack_public_path__ + "static/prog5-f35c4d671097d2098780f4a3c41cd7c1.mp4";